var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"font-size":"48px","text-align":"center","color":"red","margin-top":"30%"}},[_vm._v("404")])
}
var staticRenderFns = []

export { render, staticRenderFns }